import type { RxDocument } from 'rxdb'
import { FEATURE_TO_COINS } from 'shared/feature-to-coins'
import { toast } from 'ui/sonner'

import { apiClient } from '~/api/client'
import type { Card } from '~/db/types'
import { useAccountStore } from '~/stores/account'

import { streamExample } from './stream-example'

type AutofillCardPronunciationAndExampleOptions = {
  learnLanguageLabel: string
  onExampleCoinsLimit?: () => void
}

export const autofillCardPronunciationAndExample = async (
  cardDoc: RxDocument<Card>,
  { learnLanguageLabel, onExampleCoinsLimit }: AutofillCardPronunciationAndExampleOptions,
) => {
  const language = learnLanguageLabel || 'en'
  const languageQuery = `&language=${language}`

  if (!cardDoc.examples)
    void streamExample(cardDoc, cardDoc.learnText, cardDoc.sourceText, languageQuery).catch(() => {
      onExampleCoinsLimit?.()
    })

  if (cardDoc.pronunciation) return

  try {
    const { data: { pronunciation } = {} } = await apiClient.GET('/pronunciation', {
      params: {
        query: { language, text: cardDoc.learnText },
      },
    })

    if (!pronunciation) {
      console.error({
        message: `No pronunciation for ${cardDoc.learnText} in ${language}`,
      })
      return
    }

    await cardDoc.incrementalPatch({ pronunciation })
    useAccountStore.getState().decreaseCoins(FEATURE_TO_COINS.pronunciation)
  } catch (error) {
    toast.error('Network error')
    console.error({ message: 'Network error', error })
    throw error
  }
}
